
import { CartItem } from "@/types/marketplace";

export const calculateShippingCost = (items: CartItem[], hasCustomPC: boolean, hasOnlyMarketplace: boolean): number => {
  // Calculate subtotal before tax
  const subtotal = items.reduce((total, item) => total + item.price * item.quantity, 0);
  
  // Add $30 shipping for orders under $500
  if (subtotal < 500) {
    return 30;
  }
  
  // Free shipping for orders $500 and above
  return 0;
};

export const getCustomPCSubtotal = (items: CartItem[]): number => {
  return items
    .filter(item => item.product_type === 'custom')
    .reduce((total, item) => total + item.price * item.quantity, 0);
};
